import { render, staticRenderFns } from "./CustomerCategoryList.vue?vue&type=template&id=7f986210"
import script from "./CustomerCategoryList.vue?vue&type=script&lang=js"
export * from "./CustomerCategoryList.vue?vue&type=script&lang=js"
import style0 from "./CustomerCategoryList.vue?vue&type=style&index=0&id=7f986210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports